<template>
  <div class="main">

    <!-- Right -->
    <div class="main_r">
      <div class="title">绑定列表</div>
      <!-- search -->
      <div class="search">
        <div>
          <el-button type="primary" @click="clickQuery">查询</el-button>
          <el-button type="primary" @click="clickdialogAdd">新增</el-button>
        </div>
      </div>
      <!-- search End -->

      <!-- 列表 -->
      <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
        <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
        <el-table-column prop="deviceSn" label="设备编号" sortable="custom"></el-table-column>
        <el-table-column prop="bleSn" label="蓝牙编号" sortable="custom"></el-table-column>
        <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>
        <el-table-column prop="Operation" label="操作" width="100">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
              <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(scope.row)"></el-link>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
              <el-link :underline="false" type="danger" icon="el-icon-delete" @click="ClickDelete(scope.row)"></el-link>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="mt20">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="10"
          layout="prev, pager, next, sizes, jumper "
          :total="dataListnum">
        </el-pagination>
      </div>
      <!-- 分页 End -->
    </div>
    <!-- Right End -->

    <!---------------------- 以下是弹框内容 ---------------------->
    <!-- 新增绑定 -->
    <el-dialog title="新增绑定" :visible.sync="dialogAdd" width="26%" class="newAdd">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="addData" label-width="100px">
          <el-form-item label="蓝牙设备码" :required=true>
            <el-input v-model="addData.bleSn" placeholder="请输入蓝牙设备码"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="userMsg" :model="addData" label-width="100px">
          <el-form-item label="备注" :required=true>
            <el-input v-model="addData.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="DeviceBindblesnInsert()" >确 认</el-button>
        <el-button @click="dialogAdd = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 新增绑定 End -->

    <!-- 编辑绑定 -->
    <el-dialog title="编辑绑定" :visible.sync="dialogEdit" width="26%" class="newAdd">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="editData" label-width="100px">
          <el-form-item label="蓝牙设备码">
            <el-input v-model="editData.bleSn" placeholder="请输入蓝牙设备码"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="userMsg" :model="editData" label-width="100px">
          <el-form-item label="备注">
            <el-input v-model="editData.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="DeviceBindblesnUpdate()" >确 认</el-button>
        <el-button @click="dialogEdit = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑绑定 End -->

    <!-- 删除 -->
    <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
      <div class="confirmMsg">确定删除？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="DeviceBindblesnDelete" >确 定</el-button>
        <el-button @click="dialogDel = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 删除 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: { },
  data () {
    return {
      formLabelWidth: '120px',
      deviceSn: '',
      queryData: {
        deviceSn: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        deviceSn: '',
        bleSn: '',
        remark: ''
      },
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        bleSn: '',
        remark: ''
      },
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.queryData.deviceSn = row.deviceSn
      this.addData.deviceSn = row.deviceSn
      this.DeviceBindblesnList()
      this.DeviceBindblesnNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.DeviceBindblesnList()
      this.DeviceBindblesnNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.DeviceBindblesnList()
      this.DeviceBindblesnNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.DeviceBindblesnList()
      this.DeviceBindblesnNum()
    },
    clickQuery () {
      this.page_no = 1
      this.DeviceBindblesnList()
      this.DeviceBindblesnNum()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.bleSn = ''
      this.addData.remark = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.bleSn = row.bleSn
      this.editData.remark = row.remark
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    DeviceBindblesnList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.queryData.deviceSn
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      console.log(data)
      axios.post(Vue.prototype.global.Url_DeviceBindblesnList, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceBindblesnNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.queryData.deviceSn
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceBindblesnNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceBindblesnInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.addData.deviceSn
      data.bleSn = that.addData.bleSn
      data.remark = that.addData.remark
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceBindblesnInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceBindblesnList()
            that.DeviceBindblesnNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    DeviceBindblesnUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.bleSn = that.editData.bleSn
      data.remark = that.editData.remark
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceBindblesnUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceBindblesnList()
            that.DeviceBindblesnNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    DeviceBindblesnDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceBindblesnDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceBindblesnList()
            that.DeviceBindblesnNum()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  width: 1300px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
